<template>
    <div class="pacsInfo" style="background-color: white;height: 100%;overflow: scroll;">
		<ul>
			<li>
				<p class="mc b-b">
					<span class="xm">{{ this.hospitalName }}</span>
					<br />
					<span class="xm2">{{pacsInfo.title == null ? '' : pacsInfo.title}}</span>
				</p>
<!--				<div class="tableTitle"><span class="midText"></span></div>-->
				<span class="cell_dashed"></span>
				<p class="detail">
					<van-row>
						<van-col span="12">姓　　名：{{pacsInfo.name == null ? '' : pacsInfo.name}}</van-col>
						<van-col span="12">检查号　：{{pacsInfo.genNumber == null ? '' : pacsInfo.genNumber}}</van-col>
					</van-row>
					<van-row>
						<van-col span="12">性　　别：{{pacsInfo.sex == null ? '' : pacsInfo.sex}}</van-col>
            <van-col span="12">年　　龄：{{pacsInfo.age == null ? '' : pacsInfo.age + pacsInfo.ageType}}</van-col>
					</van-row>
					<van-row>
						<van-col span="12">科　　室：{{pacsInfo.kes == null ? '' : pacsInfo.kes}}</van-col>
						<van-col span="12">申请医生：{{pacsInfo.shenqys == null ? '' : pacsInfo.shenqys}}</van-col>
					</van-row>
					<van-row>
            <van-col span="12">就诊号　：{{pacsInfo.jiuzh == null ? '' : pacsInfo.jiuzh}}</van-col>
						<van-col span="12">床　　号：{{pacsInfo.chuangh == null ? '' : pacsInfo.chuangh}}</van-col>
					</van-row>
					<van-row>
						<van-col span="24">检查部位：{{pacsInfo.jiancbw == null ? '' : pacsInfo.jiancbw}}</van-col>
					</van-row>
					<!--
					<van-row>
						<van-col span="24">临床诊断：{{pacsInfo.linczd == null ? '' : pacsInfo.linczd}}</van-col>
					</van-row>
					 -->
					<!--
					<van-row>
						<van-col span="24">病历摘要：{{pacsInfo.binglzy == null ? '' : pacsInfo.binglzy}}</van-col>
					</van-row>
					 -->
				</p>
				<span class="cell_dashed"></span>
				<div class="tableTitle"><span class="midText"></span></div>
				<span class="cell_dashed"></span>
				<p class="detail">
                    <van-row>
						<van-col span="24">描　　述：</van-col>
					</van-row>
					<van-row>
						<van-col span="24">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							{{pacsInfo.genDescribe1 == null ? '' : pacsInfo.genDescribe1}}
						</van-col>
					</van-row>
					<span class="cell_dashed"></span>
					<van-row>
						<van-col span="24">诊　　断：</van-col>
					</van-row>
					<van-row>
						<van-col span="24">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							{{pacsInfo.genDescribe2 == null ? '' : pacsInfo.genDescribe2}}
						</van-col>
					</van-row>
                </p>
				<span class="cell_dashed"></span>
				<p class="detail">
                    <van-row>
						<van-col span="24">报告医师：{{pacsInfo.baogys == null ? '' : pacsInfo.baogys}}</van-col>
					</van-row>
					<van-row>
						<van-col span="24">审核医师：{{pacsInfo.shenhys == null ? '' : pacsInfo.shenhys}}</van-col>
					</van-row>
					<van-row>
						<van-col span="24">报告日期：{{pacsInfo.baogrq == null ? '' : pacsInfo.baogrq}}</van-col>
					</van-row>
                </p>
				<span class="cell_dashed"></span>
				<div class="tableTitle"><span class="midText"></span></div>
				<span class="cell_dashed"></span>
				<p class="detail">
                    <van-row>
						<van-col span="4">备注：</van-col>
						<van-col span="20">(1)本报告单连同胶片由病人（或家属、主管医生）同时领取，报告单及照片遗失不再补发。</van-col>
					</van-row>
					<van-row>
						<van-col span="4"></van-col>
						<van-col span="20">(2)本报告单经医生手写签名有效，在无审核医师签字为临时报告。</van-col>
					</van-row>
                </p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
    name:'PacsInfo',
    data() {
        return {
			hospitalName: process.env.VUE_APP_HOSPITAL_NAME, // 医院名称
			pacsInfo:{}
        }
	},
    mounted() {
		this.pacsInfo = this.$route.query.pacsInfo;
    }
}
</script>

<style scoped>
.pacsInfo ul li{
	height: auto;
	width: 98%;
	box-sizing: border-box;
	text-align: left;
	margin-bottom: 6px;
	padding: 5px;
	letter-spacing: 1px;
	margin-left: 1%;
	margin-right: 1%;
	border-radius: 5px;
}
.mc{
	height: 60px;
	line-height: 20px;
	color: #333333!important;
	font-size: 12px;
	padding-left: 5px;
	padding-right: 5px;
}
.detail{
	color: #646565;
	font-size: 14px;
	height: 60px;
	line-height: 30px;
	font-size: 12px;
}
.b-b{
	border-bottom: 1px solid #EEEEEE;
	text-align: center;
}
.xm{
	color: #000050;
	font-weight:bold;
	font-size: 16px;
}
.xm2{
	font-weight:bold;
	font-size: 13px;
}
.cell_dashed{
	border-bottom: 1px dashed rgb(12, 12, 12);
	height: 1px;
	margin-left: 1px;
	margin-right: 1px;
}
.tableTitle {
	position: relative;
	margin: 0 auto;
	width: 600px;
	height: 1px;
	background-color: #d4d4d4;
	text-align: center;
	font-size: 16px;
	color: rgba(101, 101, 101, 1);
}
.midText {
	position: absolute;
	left: 50%;
	background-color: #ffffff;
	padding: 0 15px;
	transform: translateX(-50%) translateY(-50%);
}
</style>
